import React from 'react';

export default function PawIcon({ size = 18, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} aria-hidden="true">
      <ellipse cx="6" cy="9" rx="2" ry="2.6"/>
      <ellipse cx="18" cy="9" rx="2" ry="2.6"/>
      <ellipse cx="9.5" cy="5.5" rx="1.7" ry="2.3"/>
      <ellipse cx="14.5" cy="5.5" rx="1.7" ry="2.3"/>
      <path d="M12 11c-3.5 0-6 2.5-6 5.5 0 1.5 1.2 2.5 2.7 2.5 1 0 1.6-.4 3.3-.4s2.3.4 3.3.4c1.5 0 2.7-1 2.7-2.5 0-3-2.5-5.5-6-5.5z"/>
    </svg>
  );
}
